jQuery(document).ready(function($){
// init accordions
    var $accordions=$('.accordion');
    $accordions.each(function(){
        var $this=$(this);
        var $h3=$this.find('h3');
        var $btn=$this.find('button');
        var $content=$this.find('#'+$btn.attr('aria-controls'));
        $btn.on('click',function(){
            var state=$btn.attr('aria-expanded') === 'true';
            $btn.attr('aria-expanded',!state);
            if(!state){
                $content.removeAttr('hidden');
            }else{
                $content.attr('hidden',true);
            }
        });
    });
});